/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PresetItemResponse } from './presetItemResponse';

export interface PresetResponse {
  id: string;
  org_id: string;
  preset_type: string;
  title: string;
  description?: string | null;
  visibility: string;
  created_by?: string | null;
  created_at: string;
  updated_at: string;
  items?: PresetItemResponse[];
  item_count?: number;
  usage_count?: number;
  creator_name?: string | null;
  creator_avatar?: string | null;
  filters_json?: string | null;
  stages_json?: string | null;
}
